import { render, staticRenderFns } from "./DepartamentoPessoalDashboardEstatisticas.vue?vue&type=template&id=37f0cafe&scoped=true"
import script from "./DepartamentoPessoalDashboardEstatisticas.vue?vue&type=script&lang=js"
export * from "./DepartamentoPessoalDashboardEstatisticas.vue?vue&type=script&lang=js"
import style0 from "./DepartamentoPessoalDashboardEstatisticas.vue?vue&type=style&index=0&id=37f0cafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f0cafe",
  null
  
)

export default component.exports